export default ":host ::ng-deep .add-acs-codes-modal .dw-grid-quick-search-action__search {\n  margin-right: 10px !important;\n}";